module.exports = __webpack_public_path__ + "img/1567068995.237ee7c4.jpg";